// extracted by mini-css-extract-plugin
export default {"ComponentName":"ComponentName_ComponentName__UuCnw","ComponentName__Text":"ComponentName_ComponentName__Text__GOL6+"};